import { render, staticRenderFns } from "./BlockedButton.vue?vue&type=template&id=6dcc3d70&"
import script from "./BlockedButton.vue?vue&type=script&lang=js&"
export * from "./BlockedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports